import logo from 'images/app_logo.svg'
import React from 'react'

function Logo() {
  return (
    <div className="logo">
      <img src={logo} alt="" />
    </div>
  )
}

export default Logo
